import type { ContactActivity } from '../typescript-types/contact/contact-activity';

import { ContactActivityState } from './contact-activity-selectors';
import { STARTING, SUCCESS, FAILURE } from '../action/util/action-name-creators';
import {
  Action,
  updateResourceByParam,
  setStateDirtyByParam,
} from '../reducers/utils/state-manager';

import { convertArrayToMap } from '../util/convert-array-to-map';

const InitialState: ContactActivityState = {
  contactActivitiesById: {},
  contactActivitiesStateByOrgId: {},
  contactActivitiesStateByJobId: {},
};

export const contactActivityReducer = (state = InitialState, action: Action) => {
  switch (action.type) {
    case STARTING('LOAD_ORG_APPLICANT_ACTIVITY'): {
      const { orgId } = action.payload.args;
      const newState = updateResourceByParam(state, 'contactActivities', 'orgId', orgId, true);
      return newState;
    }
    case SUCCESS('LOAD_ORG_APPLICANT_ACTIVITY'): {
      const {
        args: { orgId },
        data,
      } = action.payload;
      return updateResourceByParam(
        state,
        'contactActivities',
        'orgId',
        orgId,
        false,
        convertArrayToMap(data, (d: ContactActivity) => String(d.applicationActivityId)),
      );
    }
    case FAILURE('LOAD_ORG_APPLICANT_ACTIVITY'): {
      const { orgId } = action.payload.args;
      return updateResourceByParam(state, 'contactActivities', 'orgId', orgId, false);
    }
    case STARTING('LOAD_JOB_APPLICANT_ACTIVITY'): {
      const { jobId } = action.payload.args;
      const newState = updateResourceByParam(state, 'contactActivities', 'jobId', jobId, true);
      return newState;
    }
    case SUCCESS('LOAD_JOB_APPLICANT_ACTIVITY'): {
      const {
        args: { jobId },
        data,
      } = action.payload;
      return updateResourceByParam(
        state,
        'contactActivities',
        'jobId',
        jobId,
        false,
        convertArrayToMap(data, (d: ContactActivity) => String(d.applicationActivityId)),
      );
    }
    case FAILURE('LOAD_JOB_APPLICANT_ACTIVITY'): {
      const { jobId } = action.payload.args;
      return updateResourceByParam(state, 'contactActivities', 'jobId', jobId, false);
    }
    // Technically, we should do this on any action that would result in a changed feed (outbound messages & phone calls,
    // adding/removing a document, comments, etc). Since no one has ever noticed this to a degree where they've mentioned
    // it, I'm going to punt for now. Ideally, we'd have a layer of abstraction for "contact activity mutating requests"
    // that handled setting this as dirty for the right jobs, orgs, and contacts.
    case SUCCESS('UPDATE_JOB_STATUS'):
    case SUCCESS('APPLICATION_STATUS'): {
      const { jobId, orgId } = action.payload.args;
      const newState = setStateDirtyByParam(state, 'contactActivities', 'jobId', jobId);
      return setStateDirtyByParam(newState, 'contactActivities', 'orgId', orgId);
    }
    default: {
      return state;
    }
  }
};
